import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import PropaneIcon from "assets/icons/propane.svg";
import PropaneTankIcon from "assets/icons/propane_tank.svg";
import WaterDropIcon from "assets/icons/water_drop.svg";

const getAccountIcon = (type) => {
  switch (type) {
    case "ESTACIONARIO":
      return <img src={PropaneIcon} alt="Estacionario" width={24} height={24} />;
    case "PORTATIL":
      return <img src={PropaneTankIcon} alt="Portátil" width={24} height={24} />;
    default:
      return <img src={WaterDropIcon} alt="Default" width={24} height={24} />;
  }
};

const getSentimentColor = (sentiment) => {
  switch (sentiment?.toLowerCase()) {
    case "positivo":
    case "muy positivo":
      return "#388e3c";
    case "negativo":
    case "muy negativo":
      return "#d32f2f";
    case "neutral":
      return "#757575";
    default:
      return "rgb(244, 244, 244)";
  }
};

const formatLastOrderDate = (dateStr) => {
  if (!dateStr) return "N/A";
  const d = new Date(dateStr);
  return d.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const AccountInfoCard = ({ account, sentimentData }) => {
  const { alias, type, address } = account || {};

  return (
    <>
      <Grid item xs={12}>
        <Box border={1} borderColor="#e0e0e0" borderRadius={2} p={1.5} mb={2}>
          <Box display="flex" alignItems="center" gap={1.5} mb={2}>
            <Box
              width={40}
              height={40}
              bgcolor="#e3f2fd"
              borderRadius={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box
                sx={{
                  filter:
                    "invert(13%) sepia(100%) saturate(3532%) hue-rotate(205deg) brightness(95%) contrast(101%)",
                }}
              >
                {getAccountIcon(type)}
              </Box>
            </Box>
            <Typography variant="h6" style={{ fontWeight: 600, color: "#3c4858" }}>
              {alias}
            </Typography>
            <Chip
              label={account.subsegment || "N/A"}
              size="small"
              style={{
                backgroundColor: "rgb(232, 232, 232)",
                color: "rgb(29, 29, 29)",
                fontWeight: "bold",
                marginLeft: "auto",
              }}
            />
          </Box>

          <Box borderBottom={1} borderColor="#e0e0e0" mb={2} />

          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography variant="body2" color="textSecondary">
              Análisis de sentimiento
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Última interacción
            </Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap={1}>
              <Box
                width={20}
                height={12}
                bgcolor={getSentimentColor(sentimentData?.average_sentiment)}
                borderRadius={6}
              />
              <Typography variant="body2" style={{ color: "#000000" }}>
                {sentimentData?.average_sentiment && sentimentData?.last_intensity
                  ? `${sentimentData.average_sentiment}: ${sentimentData.last_intensity}`
                  : "N/A"}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Box
                width={20}
                height={12}
                bgcolor={getSentimentColor(sentimentData?.last_sentiment)}
                borderRadius={6}
              />
              <Typography variant="body2" style={{ color: "#000000" }}>
                {sentimentData?.last_sentiment && sentimentData?.last_order_date
                  ? `${sentimentData.last_sentiment}: ${formatLastOrderDate(sentimentData.last_order_date)}`
                  : "N/A"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box border={1} borderColor="#e0e0e0" borderRadius={2} p={1.5}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Dirección
          </Typography>
          <Typography variant="body2" style={{ color: "#000000" }}>
            {typeof address === "object"
              ? `${address?.street || ""} ${address?.extNumber || ""}, ${address?.colony || ""}, ${address?.municipality || ""}, ${address?.state || ""}`.trim().replace(/^,\s*/, '')
              : address || "Sin dirección"}
          </Typography>
        </Box>
      </Grid>
    </>
  );
};
